import ReactGA from 'react-ga4';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized || !MEASUREMENT_ID) return;
  ReactGA.initialize(MEASUREMENT_ID);
  ReactGA.send({ hitType: 'pageview', page: '/' });
  initialized = true;
}

export function trackEvent(category, action, label) {
  if (!initialized) return;
  ReactGA.event({ category, action, label });
}
